import React, { useEffect, useRef } from 'react';
import PropTypes from "prop-types";
import s from '../../Cliente/contacto.module.scss';

import { nonUndefined } from '../../../common/util';

const Radio = ({ onChange, checked, name, disabled, item }) => {

    const { label, value, link, img, description } = item;

    const input = useRef();

    useEffect(() => {
        input.current.checked = checked;
    }, [checked])

    const handleChange = (e) => {
        if (!input.current.disabled)
            onChange(value);
    }

    return <>
        {
            nonUndefined(img, false) && nonUndefined(img.src, false) &&
            <img src={img.src} alt={nonUndefined(img.alt)} className={nonUndefined(img.style)} />
        }
        <span onClick={(e) => handleChange(e)}>
            <input type="radio" className={s.radioInput} disabled={disabled} ref={input} name={name} value={value} defaultChecked={checked} />
            <span className={s.radioInputLabel} dangerouslySetInnerHTML={{ __html: label }} />
        </span>
        {
            nonUndefined(link, false) && nonUndefined(link.href, false) &&
            <a href={link.href} target={nonUndefined(link.target)} className={nonUndefined(link.style) +' '+ s.check_link} >{nonUndefined(link.text, 'Link')}</a>
        }
        {
            nonUndefined(description, false) && nonUndefined(description.text, false) &&
            <p className={s.description} dangerouslySetInnerHTML={{ __html: description.text }} />
        }
    </>
}

Radio.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string.isRequired
}

export default Radio;

